"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _basic_provider = _interopRequireDefault(require("./_basic_provider"));
class ContactsSettingsApi extends _basic_provider.default {
  /**
   * Represents a Contacts Settings Api.
   * @constructor
   */
  constructor(_ref) {
    let {
      userTokenFactory,
      sdkApiUrl,
      providersAccountId,
      sendWSMessage,
      httpGatewayUrl
    } = _ref;
    super({
      userTokenFactory,
      sdkApiUrl,
      providersAccountId,
      sendWSMessage,
      httpGatewayUrl
    });
  }

  /**
   * @deprecated
   * @param {String} param0.name contacts book name
   * @returns {Object} contact table schema
   */

  async getTableSchema() {
    let {
      name
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      name: 'Default'
    };
    return await this._callApi({
      method: 'get',
      path: '/contacts-books',
      queryParams: {
        name,
        projection: ['schema', 'bookId']
      },
      errorName: 'MappingsError'
    });
  }

  /**
   * @deprecated
   * @param {String} param0.bookId contacts book id
   * @param {Object} param1.schema schema of contacts table
   * @returns {Object} update stats
   */
  async updateTableSchema(_ref2) {
    let {
      bookId,
      schema
    } = _ref2;
    return await this._callApi({
      method: 'put',
      path: '/contacts-books',
      payload: {
        bookId,
        schema
      },
      errorName: 'MappingsError'
    });
  }

  /**
   * @param {String} param0.property name of column
   * @param {String} param1.bookName name of contact book
   * @param {String} param2.tableName name of contact table
   * @param {Boolean} param3.typeOf type of column - 'string', 'md', 'object', 'integer', 'double', 'date', 'array of strings', 'array of objects' or 'array of identifiers'
   * @param {Object} param4.properties properties of 'objects' and 'array of objects' types
   * @param {Boolean} param5.visibility display on UI
   * @param {Number} param6.order order of property
   * @param {String} param7.label label on UI
   * @param {String} param8.singularLabel label for singular identifier
   * @param {String} param9.triggers triggers for identifiers
   * @returns {Object} empty
   */
  async addTableColumn(_ref3) {
    let {
      property,
      bookName,
      tableName,
      typeOf,
      properties,
      visibility,
      order,
      label,
      singularLabel,
      triggers
    } = _ref3;
    return await this._callApi({
      method: 'post',
      path: '/contacts-mappings',
      payload: {
        property,
        bookName,
        tableName,
        typeOf,
        properties,
        visibility,
        order,
        label,
        singularLabel,
        triggers
      },
      errorName: 'MappingsError'
    });
  }

  /**
   * @param {Array} param0.columns names of tables columns
   * @param {String} param1.bookName name of contact book
   * @param {String} param2.tableName name of contact table
   * @returns {Object} empty
   */
  async deleteTableColumn(_ref4) {
    let {
      columns,
      bookName,
      tableName
    } = _ref4;
    return await this._callApi({
      method: 'delete',
      path: '/contacts-mappings',
      payload: {
        columns,
        bookName,
        tableName
      },
      errorName: 'MappingsError'
    });
  }

  /**
   * @param {String} param0.bookName name of contact book
   * @param {String} param1.tableName name of contact table
   * @returns {Object} contact table creation stats
   */
  async createContactsTables() {
    let {
      accountId,
      bookName,
      tableName
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return await this._callApi({
      method: 'post',
      path: '/contacts-tables',
      payload: {
        accountId,
        bookName,
        tableName
      },
      errorName: 'MappingsError'
    });
  }

  /**
   * @param {String} param0.name name of contact book
   * @param {String} param1.label name of contact book for UI
   * @param {Object} param2.source source from contact book
   * @param {Array} param3.accessPermissions array of objects access permissions
   * @param {Object} param4.schema schema of contacts table
   * @returns {Object} new contact book
   */
  async createContactBook(_ref5) {
    let {
      name,
      label,
      source,
      accessPermissions,
      schema
    } = _ref5;
    return await this._callApi({
      method: 'post',
      path: '/contacts-books',
      payload: {
        name,
        label,
        source,
        accessPermissions,
        schema
      },
      errorName: 'ContactBooksError'
    });
  }

  /**
   * @param {String} param0.name name of contact book
   * @param {String} param1.label name of contact book for UI
   * @param {Array} param2.accessPermissions array of objects access permissions
   * @param {Object} param3.schema schema of contacts table
   * @returns {Object} empty
   */
  async updateContactBook(_ref6) {
    let {
      name,
      label,
      accessPermissions,
      schema
    } = _ref6;
    return await this._callApi({
      method: 'put',
      path: '/contacts-books',
      payload: {
        name,
        label,
        accessPermissions,
        schema
      },
      errorName: 'ContactBooksError'
    });
  }

  /**
   * @param {Object} param0.projection projection of data base
   * @param {Integer} param1.v version of API
   * @param {Integer} param2.size a number of contacts to receive (default = 20)
   * @param {Integer} param3.from a number of first contact from the list (default = 0)
   * @param {String} param4.sort sorting method (default = "name:asc")
   * @param {Boolean} param5.includeCount include contact records count in answer
   * @returns {Object} with properties data: contact books list, total: contact books count
   */

  async getContactBooksList(_ref7) {
    let {
      projection,
      v,
      size,
      from,
      sort,
      includeCount
    } = _ref7;
    return await this._callApi({
      method: 'get',
      path: '/contacts-books',
      queryParams: {
        projection,
        v,
        size,
        from,
        sort,
        includeCount
      },
      errorName: 'ContactBooksError'
    });
  }

  /**
   * @param {String} param0.name name of contact book
   * @param {Object} param1.projection projection of data base
   * @param {Boolean} param2.includeCount include contact records count in answer
   * @returns {Object}  contact book
   */

  async getContactBook(_ref8) {
    let {
      name,
      projection,
      includeCount
    } = _ref8;
    return await this._callApi({
      method: 'get',
      path: '/contacts-books',
      queryParams: {
        name,
        projection,
        includeCount
      },
      errorName: 'ContactBooksError'
    });
  }

  /**
   * @param {String} param0.name name of contact book
   * @returns {Object} empty
   */

  async deleteContactBook(_ref9) {
    let {
      name
    } = _ref9;
    return await this._callApi({
      method: 'delete',
      path: '/contacts-books',
      queryParams: {
        name
      },
      errorName: 'ContactBooksError'
    });
  }

  /**
   * @param {String} param0.bookName name of contact book
   * @param {String} param1.tableName name of contact table
   * @returns {Object} contact table migrations stats
   */
  async runContactsTablesMigration() {
    let {
      accountId,
      tableName,
      bookName
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return await this._callApi({
      method: 'post',
      path: '/contacts-tables/migrations',
      payload: {
        accountId,
        tableName,
        bookName
      },
      errorName: 'ContactsMigrationError'
    });
  }

  /**
   * @returns {Object} contact table migrations stats
   */
  async runContactsServiceTablesMigration() {
    let {
      accountId
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return await this._callApi({
      method: 'post',
      path: 'contacts-tables/service/migrations',
      payload: {
        accountId
      },
      errorName: 'ServiceMigrationError'
    });
  }
  /**
   * @returns {Object} default fields stats
   */
  async getDefaultFields() {
    return await this._callApi({
      method: 'get',
      path: '/contacts-tables/default-fields',
      errorName: 'DefaultFieldsError'
    });
  }
  /**
   * @param {String} param0.bookName name of contact book
   * @param {String} param1.tableName name of contact table
   * @returns {Object} check data
   */
  async checkContactBookAndTableNameExist(_ref10) {
    let {
      bookName,
      tableName
    } = _ref10;
    return await this._callApi({
      method: 'get',
      path: '/contacts/table-and-book-exist',
      queryParams: {
        bookName,
        tableName
      },
      errorName: 'CheckNameError'
    });
  }

  /**
   * @param {String} param0.name name of contact book
   * @param {String} param1.accountId accountId of target account
   * @param {Array} param2.permissions array of permissions
   * @returns {Object} empty
   */
  async shareCrossAccountContactBook(_ref11) {
    let {
      name,
      accountId,
      permissions
    } = _ref11;
    return await this._callApi({
      method: 'post',
      path: 'contacts-books/share-cross-account',
      payload: {
        name,
        accountId,
        permissions
      },
      errorName: 'ShareContactBook'
    });
  }

  /**
   * @param {String} param0.name name of contact book
   * @param {Boolean} param1.isApproved approved or not
   * @returns {Object} empty
   */
  async approveSharingUsersList(_ref12) {
    let {
      name,
      isApproved
    } = _ref12;
    return await this._callApi({
      method: 'put',
      path: 'contacts-books/share-cross-account',
      payload: {
        name,
        isApproved
      },
      errorName: 'ApproveSharingUsersList'
    });
  }

  /**
   * @param {String} param0.name name of contact book
   * @param {String} param1.bookAccountId account Id with whom was sharing
   * @returns {Object} empty
   */
  async stopSharingContactBook(_ref13) {
    let {
      name,
      bookAccountId
    } = _ref13;
    return await this._callApi({
      method: 'delete',
      path: 'contacts-books/share-cross-account',
      queryParams: {
        name,
        bookAccountId
      },
      errorName: 'StopSharingContactBook'
    });
  }

  /**
   * @param {String} param0.name name of contact book
   * @param {String} param1.accountId account Id with needed userz list
   * @param {String} param2.projection
   * @param {Boolean} param3.chunked
   * @param {Integer} param4.limit
   * @param {String} param5.last
   * @returns {Array} users list
   */
  async getUsersListFromAnotherAccount(_ref14) {
    let {
      name,
      accountId,
      projection,
      chunked,
      limit,
      last
    } = _ref14;
    return await this._callApi({
      method: 'get',
      path: 'contacts-books/share-users-list',
      queryParams: {
        name,
        accountId,
        projection,
        chunked,
        limit,
        last
      },
      errorName: 'ShareUsersList'
    });
  }
}
var _default = ContactsSettingsApi;
exports.default = _default;